import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { useRouter } from 'next/router';

export default function B() {
    const { useLang, Link } = useGlobal();
    const { locale = 'us' } = useRouter();
    const { t } = useLang('vanlife');
    return (
        <div id="vanlife-B" className={`vanlife-B ${css['vanlife-B']}`}>
            <h2 className="title">{t('secB_title')}</h2>
            <div className="img-box">
                <EFPicture src={'/responsive/picture/vanlife/2.jpg'} alt={t('secB_title')} />
            </div>
            <p className="text">{t('secB_desc')}</p>
            <div className="links">
                <Link className="link text" href={`https://${locale}.ecoflow.com/collections/portable-power-stations`}>
                    {t('secB_link1')}
                </Link>
                <Link className="link text" href={'/wave-2-portable-air-conditioner'}>
                    {t('secB_link2')}
                </Link>
            </div>
        </div>
    );
}
